module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/217-virgin-islands-f9a221be333577bb27db5ae7562c1922.svg";